export type addPrefixToObject<T, P extends string> = {
  [K in keyof T as K extends string ? `${P}${K}` : never]: T[K]
}

export function removePrefix<Y>(props: object, prefix: string) {
  return Object.entries(props)
    .filter(([key]) => key.startsWith(prefix))
    .reduce((acc, [key, value]) => {
      const newKey = key.replace(prefix, '')
      return { ...acc, [newKey]: value }
    }, {}) as Y
}
